export const LIST_PROVIDERS = 'LIST_PROVIDERS';
export const LIST_PROVIDERS_SUCCESS = 'LIST_PROVIDERS_SUCCESS';
export const LIST_PROVIDERS_FAILED = 'LIST_PROVIDERS_FAILED';
